import { useTestUsers } from '../hooks/use-test-users';

interface Props {
  value: string;
  onChange: (email: string) => void;
  /**
   * ISO 3166-1 alpha-2 (uppercase) or 'global'/null to scope which test
   * users appear. Passing undefined returns all users (legacy behaviour).
   */
  country?: string | null;
}

export function TestUserPicker({ value, onChange, country }: Props) {
  const { data, isLoading, error } = useTestUsers(country);

  if (isLoading) {
    return <div className="muted">Loading test users…</div>;
  }
  if (error) {
    return (
      <div className="error">
        Could not load test users: {error.message}
      </div>
    );
  }

  const users = data ?? [];
  if (users.length === 0) {
    return (
      <div className="muted">
        No test users for this country yet. Add fixtures in
        <code className="mono"> test-users.const.ts</code> on the backend.
      </div>
    );
  }

  return (
    <select
      className="select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">Pick a test user…</option>
      {users.map((u) => (
        <option key={u.email} value={u.email}>
          {u.email.replace('@newswave.test', '')} — {u.desc}
        </option>
      ))}
    </select>
  );
}
